module.exports = __webpack_public_path__ + "static/media/gsb-iconNew-Arrival.ab64f1e0.svg";